import {
    CalendarOutlined,
    DropboxOutlined,
    InfoCircleOutlined,
    PieChartOutlined,
} from "@ant-design/icons";
import { AssignmentResponseType, AssignmentType } from "tm-shared/types";

export const ASSIGNMENT_VOCABULARY = {
    [AssignmentType.Task]: {
        label: "Задача",
        value: AssignmentType.Task,
        icon: CalendarOutlined,
    },
    [AssignmentType.InfoCommunication]: {
        label: "Інформування та комунікація",
        value: AssignmentType.InfoCommunication,
        icon: InfoCircleOutlined,
    },
    [AssignmentType.Inventory]: {
        label: "Інвентаризація",
        value: AssignmentType.Inventory,
        icon: DropboxOutlined,
    },
    [AssignmentType.PricesDistribution]: {
        label: "Ціни роздріб",
        value: AssignmentType.PricesDistribution,
        icon: PieChartOutlined,
    },
};

export const ASSIGNMENT_RESPONSE_VOCABULARY = {
    [AssignmentResponseType.Bool]: {
        label: "Так/Ні",
        value: AssignmentResponseType.Bool,
    },
    [AssignmentResponseType.Photo]: {
        label: "Фото",
        value: AssignmentResponseType.Photo,
    },
    [AssignmentResponseType.Text]: {
        label: "Текст",
        value: AssignmentResponseType.Text,
    },
    [AssignmentResponseType.PhotoText]: {
        label: "Фото і текст",
        value: AssignmentResponseType.PhotoText,
    },
};
